import { render, staticRenderFns } from "./userPagesTitle.vue?vue&type=template&id=655da437&"
import script from "./userPagesTitle.vue?vue&type=script&lang=js&"
export * from "./userPagesTitle.vue?vue&type=script&lang=js&"
import style0 from "./userPagesTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports